export const apiPath = '/v2/travel_settings';
const actionType = 'TRAVEL_SETTINGS';

export const bulkActionType = `${actionType}_BULK`;

export default actionType;
